import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from 'store/hooks';
import { ChartPie, Hash } from 'lucide-react';
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarRail,
  useSidebar,
} from 'components/ui/sidebar';
import { NavUser } from 'components/fragment';
import { PALMETTO_LOGO_BASE64 } from '@/common/constants';
import { tokenVerificationSelector } from 'store/auth/auth.selector';

// Menu items.
const items = [
  {
    title: 'Event list',
    url: '/dashboard',
    icon: Hash,
  },
  {
    title: 'File library',
    url: '/dashboard/filelibrary',
    icon: ChartPie,
  },
];

export function AppSidebar() {
  const navigate = useNavigate();
  const accountInfo = useAppSelector(tokenVerificationSelector);
  const { state } = useSidebar();
  const isMinimized = state === 'collapsed';
  console.log('🚀 AppSidebar isMinimized: ', isMinimized);

  const user: { firstName: string; lastName: string; email: string } = useMemo(() => {
    if (
      accountInfo &&
      accountInfo?.pvPersonGivenName &&
      accountInfo?.pvPersonSurName &&
      accountInfo?.email
    ) {
      return {
        firstName: accountInfo.pvPersonGivenName,
        lastName: accountInfo.pvPersonSurName,
        email: accountInfo.email,
      };
    }
    return { firstName: '', lastName: '', email: '' };
  }, [accountInfo]);

  const handleMenuItemClick = (url: string) => {
    navigate(url);
  };

  return (
    <Sidebar className={'ci:z-50'}>
      <SidebarHeader>
        <div className={'ci:flex ci:gap-4 ci:items-center ci:pt-4'}>
          <img
            src={`data:image/png;base64,${PALMETTO_LOGO_BASE64}`}
            alt='Palmetto Logo'
            className='ci:h-8 ci:w-auto ci:object-contain'
          />
          <p className={'ci:text-foreground ci:font-medium'}>
            {import.meta.env.VITE_APP_TITLE}
          </p>
        </div>
      </SidebarHeader>
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>Projects</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {items.map((item) => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton asChild onClick={() => handleMenuItemClick(item.url)}>
                    <span>
                      <item.icon />
                      <span>{item.title}</span>
                    </span>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
      <SidebarFooter>
        <NavUser user={user} />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}

export default AppSidebar;
